/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */
import {
  Train,
  TrainType
}                          from './train';
import { Track }           from './track';
import { TrainClass }      from './train.class';


/**
 *
 * @class ExponentialTrain
 *
 * @brief variety that spreads some number trains per day, randomly throughout the day.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2019
 *
 */
export class ExponentialTrain extends Train {

  /** @var _perDay how many trains to run each day */
  public _perDay: number = 0;

  /** @var _seed randomization setup */
  public   _seed: number = 0;

  /** @brief standard constructor */
  constructor(        id: number,
                    name: string,
                   paths: (Track|null)[][],
              trainClass: TrainClass|null,
                 tonnage: number,
                  length: number,
                priority: number,
                overtake: number,
                  perDay: number,
                    seed: number,
                     nth: number) {

    super(id, name, paths, trainClass, tonnage, length, priority, overtake, nth);

    this._type   = TrainType.EXPONENTIAL;
    this._perDay = perDay;
    this._seed   = seed;
  }

  /** @brief helper to make a new instance of this template */
  public override clone(): Train {

    let newTrain: ExponentialTrain = new ExponentialTrain(
      this._id,
      this._name,
      this._paths,
      this._tc,
      this._tonnage,
      this._length,
      this._priority,
      this._overtake,
      this._perDay,
      this._seed,
      -1
    );

    newTrain._type      = this._type;
    newTrain._tag       = this._tag;
    newTrain._stops     = this._stops;
    newTrain._workFlags = this._workFlags;

    return newTrain;

  }

  /** when editing fails because the value given was entirely unusable, fill in a default but still bad value */
  public override defaultBadValue(field:  string): void {

    /*
     * this method is required because they may give a value like "undefined" which can't
     * match any of our types, it can't be "set" as the value.  In cases like that, we fill
     * in a typed value that does match the type of the field, but It's still a bad value,
     * to reflect that the edit is invalid.
     *
     */

    switch (field) {

      case 'seed':      this._seed      = -1; return ;
      case 'daily':     this._perDay    = -1; return ;
    }

    super.defaultBadValue(field);
  }

  /** edit this field on this train (if applicable), return true if edit succeeded */
  public override edit(field: string, value: any): boolean {

    const param:  {field: string, value: any} = this.prepare(field, value);

    switch (param.field) {

      case 'seed':      this._seed      = param.value as number;     return this.validate();
      case 'daily':     this._perDay    = param.value as number;     return this.validate();
    }

    return super.edit(field, value);
  }

  /** check if this value *would* be valid for this field */
  public override checkValue(field: string, value: any): string {

    let f: string|null = this.normalizeFieldName(field);

    if (!f) {

      return '';
    }

    switch (f) {

      case 'seed': {

        if (!this.isPositiveNumber(value)) {

            return `Random seed can not be negative number.`;
          }
        }
        break;

      case 'daily': {

        if (!this.isPositiveNumber(value)) {

            return `Trains per day can not be negative number.`;
          }
        }
        break;
    }

    /* no obvious error */

    return super.checkValue(f, value);
  }

  /** reset the list of invalid fields, based on current values */
  public override validate(): boolean {

    super.validate();

    /* sub-class validation ... */

    return this.validateValues([
      ['seed',      this._seed,      'seed'],
      ['daily',     this._perDay,    'daily']
    ]);
  }
}
